import { render, staticRenderFns } from "./ManageStallionNumber.vue?vue&type=template&id=7144aa72&"
import script from "./ManageStallionNumber.vue?vue&type=script&lang=js&"
export * from "./ManageStallionNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports